import edit from './edit';
import save from './save';
import cardBlockMeta from './block.json';
import { cardIcon as icon } from './icons';
import attributeVisibility from '@components/visibility/attributes.json';
import attributeClassDropDown from '@components/class-dropdown/attributes.json';
import LinkAttributes from '@components/link/attributes.json';
import { getBlockLabelByName } from '@helpers/utils';
import './style.scss';

const { registerBlockType } = wp.blocks;

const { name, ...settings } = cardBlockMeta;

const attributes = {
  ...settings.attributes,
  ...attributeClassDropDown,
  ...attributeVisibility,
  ...LinkAttributes,
};
registerBlockType(name, {
  ...settings,
  icon,
  attributes,
  edit,
  save,
  __experimentalLabel: (attributes) =>
    getBlockLabelByName(attributes, settings.title),
});
